import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet, Text, View } from 'react-native';

import { primitive } from 'styles/constants/primitives';

export const DialogHeader = ({ title }: { title: string }) => (
  <View style={styles.headerContainer}>
    <Icon variant="errorFill" size="lg" style={styles.icon} />
    <Text style={styles.headingText}>{title}</Text>
  </View>
);

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    marginBottom: 8,
  },
  headingText: {
    fontSize: primitive.fontSizes['2xl'],
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    textAlign: 'center',
  },
});
